<ng-container *ngIf="nodeId">
  <adf-viewer
    [ngClass]="{
      'right_side--hide': !showRightSide
    }"
    [nodeId]="nodeId"
    [allowNavigate]="navigateMultiple"
    [allowRightSidebar]="true"
    [allowPrint]="false"
    [showRightSidebar]="true"
    [allowDownload]="false"
    [allowFullScreen]="false"
    [canNavigateBefore]="!!previousNodeId"
    [canNavigateNext]="!!nextNodeId"
    [overlayMode]="true"
    (showViewerChange)="onVisibilityChanged($event)"
    (navigateBefore)="onNavigateBefore($event)"
    (navigateNext)="onNavigateNext($event)"
  >
    <adf-viewer-sidebar *ngIf="infoDrawerOpened$ | async">
      <aca-info-drawer [node]="selection.file"></aca-info-drawer>
    </adf-viewer-sidebar>

    <adf-viewer-open-with *ngIf="openWith.length">
      <ng-container *ngFor="let action of openWith; trackBy: trackByActionId">
        <app-toolbar-menu-item [actionRef]="action"></app-toolbar-menu-item>
      </ng-container>
    </adf-viewer-open-with>

    <adf-viewer-toolbar-actions *ngIf="!simplestMode">
      <ng-container *ngFor="let action of viewerToolbarActions; trackBy: trackByActionId">
        <aca-toolbar-action [actionRef]="action"></aca-toolbar-action>
      </ng-container>
    </adf-viewer-toolbar-actions>
  </adf-viewer>
</ng-container>
